import { Outlet, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import { logoForTheme } from '@/lib/brand';
import { Button } from '@/components/ui/button';
import { ShieldAlert, ArrowLeft, Menu } from 'lucide-react';
import { useState } from 'react';
import PantallaSegura from '@/components/PantallaSegura';

export default function DashboardLayout() {
  const { impersonating, stopImpersonation, user } = useAuth();
  const { theme } = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleStopImpersonation = async () => {
    const restoredUser = await stopImpersonation();
    if (restoredUser?.role === 'superadmin') {
      navigate('/backoffice');
    }
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <main className="flex-1 lg:ml-56 p-4 sm:p-6 lg:p-8 min-w-0">
        {/* Mobile header */}
        <div className="lg:hidden flex items-center justify-between mb-4 -mt-1">
          <button onClick={() => setMobileOpen(true)} className="p-2 rounded-lg bg-white/5 border border-white/10 text-muted-foreground hover:text-white" data-testid="mobile-menu-btn">
            <Menu className="w-5 h-5" />
          </button>
          <img src={logoForTheme(theme)} alt="LEADCEM" className="h-6 w-auto object-contain" />
          <div className="w-9" />
        </div>
        {impersonating && (
          <div className="mb-6 p-3 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-between flex-wrap gap-2" data-testid="impersonation-bar">
            <div className="flex items-center gap-3">
              <ShieldAlert className="w-5 h-5 text-blue-400 shrink-0" />
              <div>
                <p className="text-sm font-semibold text-blue-300">Modo Suplantacion Activo</p>
                <p className="text-xs text-blue-400/60">Viendo como: <strong className="text-blue-300">{user?.company?.name}</strong> ({user?.name})</p>
              </div>
            </div>
            <Button size="sm" onClick={handleStopImpersonation} className="bg-blue-500/20 hover:bg-blue-500/30 text-blue-300 border border-blue-500/30" data-testid="stop-impersonation-btn">
              <ArrowLeft className="w-4 h-4 mr-1" /> Volver
            </Button>
          </div>
        )}
        {/* Una pantalla que falla ya no deja todo en negro: se atrapa aqui,
            el menu sigue en pie y el usuario puede reintentar o irse. */}
        <PantallaSegura clave={location.pathname}>
          <Outlet key={location.pathname} />
        </PantallaSegura>
      </main>
    </div>
  );
}
